import { createContext } from "react";
import { LocationsContextData } from "./LocationsContext.types";

const LocationsContext = createContext<{
    data?: LocationsContextData;
}>({});

export default LocationsContext;
